export default {
  practiceInfo: state => state.practiceInfo
}
